import { useFormikSubmit } from "@certn/api";
import {
  BasicButton,
  DialogContent,
  DialogFooter,
  DialogHeader,
  PrimaryButton,
  Stack,
  showToast,
} from "@certn/cascadia-react";
import { Form, Formik, FormikErrors } from "formik";
import { useTranslation } from "react-i18next";

import { FailedToVerifyWebhookMessage } from "../form-components/FailedToVerifyWebhookMessage";
import { WebhookURLInput } from "../form-components/WebhookURLInput";

interface Props {
  apiConfigurationID: string;
  onSuccess: () => void;
  close: () => void;
}

interface WebhookFormValues {
  webhook_url?: string;
  public_api_configuration: string;
}

interface Errors extends FormikErrors<WebhookFormValues> {
  verification?: string;
}

export function CreateWebhookForm({
  apiConfigurationID,
  onSuccess,
  close,
}: Props) {
  const { t } = useTranslation();

  const { submit, isSubmitting } = useFormikSubmit(
    "/api/internal/client-portal/public-api/webhooks/create/",
    {
      onSuccess: () => {
        onSuccess();
        showToast(t("Webhook created successfully"), { type: "success" });
        close();
      },
    }
  );

  return (
    <Formik<WebhookFormValues>
      initialValues={{
        public_api_configuration: apiConfigurationID,
      }}
      onSubmit={submit}
    >
      {(formProps) => {
        const errors: Errors = formProps.errors;
        return (
          <Form>
            <DialogHeader>{t("Create webhook")}</DialogHeader>
            <DialogContent>
              <Stack gap="space-4">
                <FailedToVerifyWebhookMessage error={errors["verification"]} />
                <WebhookURLInput />
              </Stack>
            </DialogContent>
            <DialogFooter>
              <BasicButton
                onPress={close}
                testID="cancel"
                isDisabled={isSubmitting}
              >
                {t("Cancel")}
              </BasicButton>
              <PrimaryButton
                testID="submit-create-webhook"
                type="submit"
                isDisabled={isSubmitting}
              >
                {t("Create webhook")}
              </PrimaryButton>
            </DialogFooter>
          </Form>
        );
      }}
    </Formik>
  );
}
